import React, { Component } from 'react';
import cn from 'classnames';
import { getAvatarColorByUserId, getUserInitials } from '../../utils/utilsChat';
import { mergeClassNames, prefixPrevProps } from '../../utils/utilsGlobal';
import originalStyles from './Avatar.scss';


export class Avatar extends Component {

  state = {
    avatarUrl: null,
    avatarColor: null,
    avatarLetters: '',
    avatarDefaultColor: false,
  };

  DEFAULT_COLOR = '#0033FF';

  componentDidMount(){
    const { room, user } = this.props;
    this.setAvatarData(room, user);
  }

  componentDidUpdate(prevProps){
    const { room, user } = this.props;
    const { prevRoom, prevUser } = prefixPrevProps(prevProps);

    if (room !== prevRoom || user !== prevUser) {
      this.setAvatarData(room, user);
    }
  }

  getAvatarUrl = (room, user) => {
    return room?.avatar?.thumbnails[0].url || user?.avatar?.thumbnails[0].url;
  };

  getAvatarColor = (room, user) => {
    if (room?.omnichannelClientId) {
      return getAvatarColorByUserId(room.omnichannelClientId);
    }
    else if (user?.id) {
      return getAvatarColorByUserId(user.id);
    }
  };

  getAvatarLetters = (room, user) => {
    if (room?.id) {
      const isNumericTitle = room.title.replace(/[^\d]/ig, '').length >= 10;
      if (isNumericTitle) {
        // last two digits
        return room.title.replace(/[^\d]/ig, '').slice(-2);
      }
      else {
        // first letter
        const firstLetter = room.title.trim().replace(/[^\w]+/ig, '')[0];
        return firstLetter ? firstLetter.toUpperCase() : room.title[0];
      }
    }
    else if (user?.id) {
      return getUserInitials(user);
    }
  };

  setAvatarData = (room, user) => {
    let avatarColor = null;
    let avatarLetters = '';
    let avatarDefaultColor = false;
    let avatarUrl = this.getAvatarUrl(room, user);

    if (!avatarUrl) {
      avatarLetters = this.getAvatarLetters(room, user);
      avatarColor = this.getAvatarColor(room, user);
    }
    if (!avatarColor && !avatarUrl) {
      avatarColor = this.DEFAULT_COLOR;
      avatarDefaultColor = true;
    }
    this.setState({
      avatarUrl,
      avatarColor,
      avatarLetters,
      avatarDefaultColor,
    });
  };

  render(){
    const { className, overrideClassNames, room, user } = this.props;
    const { avatarUrl, avatarColor, avatarLetters, avatarDefaultColor } = this.state;

    const styles = mergeClassNames(originalStyles, overrideClassNames);
    const channel = room?.omnichannelChannelType || user?.omnichannelChannelType;
    const containerStyle = {};

    if (avatarUrl) {
      containerStyle.backgroundImage = `url(${avatarUrl})`;
    }
    else {
      containerStyle.backgroundColor = avatarColor;
    }

    return (
      <span className={cn({
        [className]: true,
        [styles.avatar]: true,
        [styles.avatarPhoto]: avatarUrl,
        [styles.avatarDefaultColor]: avatarDefaultColor,
      })} style={containerStyle}>
        {avatarLetters}
        {Boolean(channel) && (
          <i className={cn({
            [styles.avatarIcon]: true,
            [styles.avatarIconWhatsapp]: channel === 'WHATSAPP',
            [styles.avatarIconTelegram]: channel === 'TELEGRAM',
            [styles.avatarIconFacebook]: channel === 'FACEBOOK',
            [styles.avatarIconViber]: channel === 'VIBER',
            [styles.avatarIconVK]: channel === 'VKONTAKTE',
          })}/>
        )}
      </span>
    );
  }
}
